<template>
  <v-dialog v-model="showAddOrganisation" width="1200" persistent>
    <v-card>
      <div id="queryHolder"></div>

      <v-banner sticky class="primary custom-padding py-0">
        <v-row class="text-left pb-0">
          <v-col cols="12" md="3" lg="2" class="py-0 pt-5">
            <span class="white--text custom-title">Add an Organisation</span>
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pb-0">
            <ValidationProvider
              name="Wholesaler"
              rules="required"
              v-slot="{ errors }"
            >
              <v-autocomplete
                :items="wholesalerData"
                label="Wholesaler"
                outlined
                placeholder="Select wholesaler"
                :error-messages="
                  wholesalerAccount === 0 ? 'Wholesaler is required' : errors
                "
                :error="wholesalerAccount === 0"
                :item-text="setCompany"
                item-value="accountNumber"
                dense
                dark
                v-model="wholesalerAccount"
                :readonly="wholesalerData.length === 1"
                :disabled="isOriginal"
                @change="wholesalerChanged"
              ></v-autocomplete>
            </ValidationProvider>
            <v-spacer></v-spacer>
          </v-col>
        </v-row>
      </v-banner>

      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-text class="pt-0">
          <v-divider class="mt-4 mb-8"></v-divider>
          <organisation-form
          ref="organisationForm"
          :is-editing="false"
          :query="{}"
          :wholesalerAccount="wholesalerAccount"
          @close="closeQuery"
          ></organisation-form>
<!--          <query-available-slots-->
<!--            ref="queryAvailableSlotsNbn"-->
<!--            @showSlotsResultSection="showSlotsResultSection"-->
<!--          ></query-available-slots>-->
        </v-card-text>

<!--        <available-slots-results-->
<!--          ref="queryAvailableSlotsResultsNbn"-->
<!--          class="mt-5"-->
<!--        ></available-slots-results>-->

        <div class="text-right fixed-bar rtl primary py-4">
          <v-btn @click="closeQuery()" class="mr-4">Close</v-btn>
        </div>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import OrganisationForm from "@/components/organisationManagement/organisation-form";
export default {
  name: "add-organisation",
  components: {OrganisationForm},
  props: {
    showAddOrganisation: { type: Boolean, required: true },
  },
  data: () => ({
    wholesalerAccount: 0
  }),
  methods:{
    showSlotsResultSection(details) {
      let vm = this;
      // vm.$refs.queryAvailableSlotsResultsNbn.showSlotsResult = true;
      // vm.$refs.queryAvailableSlotsResultsNbn.result = details;
    },
    closeQuery() {
      let vm = this;
      document.getElementById("queryHolder").scrollIntoView({behavior: "smooth"});
      vm.$refs.observer.reset();
      vm.$emit("closeQuery");
    },
    checkLayer() {
      const vm = this;
      if(vm.wholesalerData.length === 1){
        vm.retrieveFeatures(vm.wholesalers[0].accountNumber);
      } else {
        vm.retrieveFeatures(vm.wholesalerAccount);
      }
    },
    setCompany(details) {
      let text = "";
      if (details.company !== "" && details.company !== null)
        text = details.company;
      else if (details.name !== "" && details.name !== null)
        text = details.name;
      return text;
    },
    wholesalerChanged() {
      let vm = this;
      vm.getUBCustomers({ id: vm.wholesalerAccount, keyword: "all" });
      vm.checkLayer();
    },
    setWholesaler(wholesalerValue) {
      let vm = this;
      if(wholesalerValue != null)
      {
        vm.wholesalerAccount = wholesalerValue;
      } else {
        vm.getWholesalers()
          .then((data) => {
            if (!vm.isUserMember || data.length === 1) {
              vm.selectedWholeSaler = data[0];
              if(vm.selectedWholeSaler.is_radius_user === "n")
              {
                const columnIndex = vm.$parent.columnDefs.findIndex(column => column.field === "radiusStatus");
                if (columnIndex !== -1) {
                  vm.$parent.columnDefs.splice(columnIndex, 1);
                  // Optionally, you can force the grid to refresh to apply the changes
                  // vm.$refs.agGrid.api.setColumnDefs(this.columnDefs);
                  // vm.$refs.agGrid.api.refreshHeader();
                }
              }
            } else if(wholesalerValue != null) {
              vm.selectedWholeSaler = data.find( x=> x.accountNumber === wholesalerValue);
            } else vm.selectedWholeSaler = null;
          })
          .catch(() => {});
      }
    },
  },
  computed: {
    wholesalerData: function () {
      let vm = this;
      let data = null;
      if (vm.impersonating !== null) {
        if (vm.isUserMember) {
          data = vm.wholesalers;
          if (!vm.isOriginal) {
            if (vm.wholesalers.length > 1)
              vm.wholesalerAccount = 0;
            else {
              vm.wholesalerAccount = vm.wholesalers[0].accountNumber;
            }
          }
        } else {
          // data = vm.wholesalers.filter(
          //   (x) => x.oneLoginEmail === vm.user.email
          // );
          data = vm.wholesalers.filter(
            (x) => x.oneLoginEmail === vm.impersonating.impersonateEmail
          );
          vm.selectedWholeSaler = data[0];
        }
      } else {
        if (vm.isAdmin) {
          data = vm.wholesalers;
          if (vm.isOriginal)
            vm.selectedWholeSaler = vm.wholesalers.filter(
              (x) =>
                x.accountNumber === vm.selectedOrder.wholesalerAccountNumber
            ).wholesalerAccountNumber;
          else vm.selectedWholeSaler = null;
        } else {
          data = vm.wholesalers.filter(
            (x) => x.oneLoginEmail === vm.user.email
          );
          vm.selectedWholeSaler = data[0];
        }
      }
      return data;
    },
  }
}
</script>

<style scoped>

</style>
